import { SxProps, Theme } from '@mui/material';

export const styles: Record<
  | 'container'
  | 'closeButton'
  | 'header'
  | 'content'
  | 'list'
  | 'listItem'
  | 'faq'
  | 'userMessage'
  | 'systemMessage'
  | 'markdownContainer',
  SxProps<Theme>
> = {
  closeButton: {
    '&:hover': {
      background: (theme) => theme.palette.gray[300],
    },
    background: (theme) => theme.palette.gray[200],
    borderRadius: '50%',
    boxShadow: 'none',
    position: { sm: 'absolute', xxs: 'static' },
    right: 10,
    top: 16,
  },
  container: {
    // custom breakpoint to match crisp chat window
    '@media (max-width: 479px)': {
      bottom: 0,
      height: '100vh',
      right: 0,
      width: '100%',
    },
    bottom: 160,
    display: 'flex',
    flexDirection: 'column',
    height: 640,
    position: 'fixed',
    right: 24,
    width: 456,
    zIndex: 1000001,
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    justifyContent: 'space-between',
    padding: (theme) => theme.spacing(3),
    width: '100%',
  },
  faq: {
    background: (theme) => theme.palette.gray[100],
    borderRadius: '10px',
    cursor: 'pointer',
    padding: (theme) => theme.spacing(1.5),
  },
  header: {
    alignItems: 'center',
    backgroundColor: 'inherit',
    display: 'flex',
    flexDirection: 'row',
    gap: 1,
    height: 52,
    justifyContent: { sm: 'center', xxs: 'space-between' },
    minHeight: 52,
    padding: (theme) => theme.spacing(1, 2),
    position: 'sticky',
    top: 0,
    width: '100%',
    zIndex: 2,
  },
  list: {
    // custom breakpoint to match crisp chat window
    '@media (max-width: 479px)': {
      maxHeight: 'calc(100vh - 160px)',
    },
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    maxHeight: 458,
    overflow: 'auto',
    padding: 0,
  },
  listItem: {
    display: 'flex',
    padding: 0,
  },
  markdownContainer: {
    '& > :first-of-type': {
      marginTop: 0,
    },
    '& > :last-of-type': {
      marginBottom: 0,
    },
    fontSize: '15px',
  },
  systemMessage: {
    marginBottom: (theme) => theme.spacing(2),
    padding: 0,
  },
  userMessage: {
    background: (theme) => theme.palette.gray[100],
    borderRadius: '10px',
    marginBottom: (theme) => theme.spacing(2),
    padding: (theme) => theme.spacing(1.5),
  },
};
